module.exports = __webpack_public_path__ + "img/form-6.3efe6911.png";